/** @format */
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import getRedirectionLink from '../../../utils/helper';
import { API_URL } from 'src/constants';

const CardLink = ({ link, mainLink }: { link: { link?: string; linkTarget?: string; linkTitle?: string }; mainLink?: boolean }) => {
  return link.link ? (
    <a
      href={getRedirectionLink(link)}
      target={`${link.linkTarget === '_blank' ? '_blank' : ''}`}
      className={mainLink && 'main-link'}>
      <span className="card-text">{link.linkTitle}</span>
    </a>
  ) : (
    <Link to={getRedirectionLink(link)} className={mainLink && 'main-link'}>
      <span className="card-text">{link.linkTitle}</span>
    </Link>
  );
};

const CardMultiLink = props => {
  const { t } = useTranslation();
  const data = props.data;
  // const { width, height, ref } = useResizeDetector();

  let image = API_URL + data.image;
  if (!data) return <></>;

  return (
    // <div className={`card-multi-link ${useStyles().card}`} ref={ref} data-width={width} data-height={height}>
    <div className={`card-multi-link ${props.highlight && 'card-multi-link--highlight'}`}>
      {/* <img src={image} alt="card-icon" /> */}
      <div className="card-flex">
        <div className="card-title-container">
          <h2 className={`card-title`}>{data.title}</h2>
          {data.links && <CardLink link={data.links[0]} mainLink />}
        </div>
        {data.links && (
          <div className="others-link">
            <h4>{t('widget.directLinks')}</h4>
            {data.links.slice(1).map((link, index) => {
              return <CardLink link={link} key={index} />;
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export { CardMultiLink };
